import { Link } from "react-router-dom";

const WebisteDetails = ({site = {}, subscriptionDetails={}}) => {
   
    return (
        <div className="mjs-dash-section mjs-dash-section-half">
            <div className="mjs-dash-sec-header"><h4>Website Details</h4></div>
            <div className="mjs-dash-inner-container">
                <div className="mjs-dash-row">
                    <span>Site Name</span>
                    <span>{subscriptionDetails?.subType ? site.name + " - " + subscriptionDetails.subType : site.name || '-'}</span>
                </div>
                <div className="mjs-dash-row">
                    <span>Email</span>
                    <span>{site.email || '-'}</span>
                </div>
                <div className="mjs-dash-row">
                    <span>Phone</span>
                    <span>{site.phone || '-'}</span>
                </div>
                <div className="mjs-dash-row">
                    <span>Address</span>
                    <span>{site.address || '-'}</span>
                </div>
                <div className="mjs-dash-row">
                    <span>Status</span>
                    <span>{site.status || '-'}</span>
                </div>
                <div className="mjs-dash-row">
                    <span>Site URL</span>
                    <span><Link className="mjs-link" target="_blank" to={site.siteUrl}>{site.name}</Link></span>
                </div>
            </div>
        </div>
    );
};

export default WebisteDetails;
